<template>
  <div>
  <!--設定画面-->
  <v-tabs
    vertical
    dark
    background-color="#2B2B2B"
    hide-slider
    :height="isSp ? '100dvh' : '90vh'"
  >
    <v-tab class="font-weight-bold " data-testid="gotoBaseManage">
      基本設定
    </v-tab>
    <v-tab v-if="Object.keys(attributionDef).length" class="font-weight-bold ">
      属性設定
    </v-tab>
    <v-tab class="font-weight-bold ">
      通知設定
    </v-tab>
    <v-tab class="font-weight-bold ">
      言語設定
    </v-tab>
    <v-tab class="font-weight-bold " v-if="isAdmin&&!isSp">
      アナウンス
    </v-tab>  
    <v-tab class="font-weight-bold " v-if="isAdmin">
      Lid順設定
    </v-tab>
    <v-tab class="font-weight-bold " v-if="isAdmin">
      Lidフォルダ作成
    </v-tab>
    <v-tab class="font-weight-bold " v-if="isAdmin">
      Lidフォルダ削除
    </v-tab>  
    <v-tab class="font-weight-bold ">
      ポリシー
    </v-tab>  
    <v-tab class="font-weight-bold " data-testid="gotoVersionInfo">
      バージョン情報
    </v-tab>

    <!--基本設定-->
    <v-tab-item :transition="false">
      <div class="d-flex pa-2">
        <p
          class="font-weight-bold mb-0"
          style="font-size:30px; color:#2B2B2B"          
        >基本設定</p>
        <v-spacer></v-spacer>
        <v-btn
          tile
          icon
          @click="$emit('closeSetting',false)"
        >
          <v-icon color="#E64550" size="50">mdi-close</v-icon>
        </v-btn>
      </div>
      <v-row class="overflow-y-auto" style="height:80vh !important;">
      <v-col cols="12" sm="3">
        <div
          class="mx-auto text-center"
        >
          <v-avatar
            size="125"
            tile
            class="mb-10 ml-4"
          >
            <v-img
              v-if="logoSrc"
              class="preview-item-file"
              :src="logoSrc_large"
              alt=""
            />
            <v-img
              src="../assets/logo/logo.png"
              class="mx-auto"
              v-else
            >
            </v-img>
          </v-avatar>
          <upImage_logo @getImageUrl="getImageUrl" :ideaImageForEdit="logoSrc" v-if="isAdmin&&!isSp"></upImage_logo>
        </div>
      </v-col>
      <v-col cols="12" sm="9">
        <v-col class="d-flex pb-0">
          <p style="font-size:24px; color:#294A66" class="mb-0">タイトル</p>
        </v-col>
        <v-col v-if="!editTitle" class="d-flex">
          <h2 class="my-2 mr-auto">{{basetitle}}</h2>
          <v-btn
            color="#707070" dark
            data-testid="gotoadminsview"
            @click="editTitle=true"
            class="rounded-xl mr-8"
            v-if="isAdmin&&!isSp"
          >
            管理
          </v-btn>  
        </v-col>
        <v-col v-else>           
          <v-text-field
            hide-details
            v-model="newbasetitle"
          ></v-text-field>
        </v-col>
        <v-col v-if="editTitle" class="d-flex">
          <v-btn rounded @click="submitBasetitle()" class="ml-2">登録</v-btn>
          <v-btn rounded @click="editTitle=false" class="ml-auto">キャンセル</v-btn>
        </v-col>

        <v-col class="pb-0">
          <div style="font-size:24px; color:#294A66">
            メンバー
          </div>
        </v-col>
        <v-col class="d-flex pb-0">
          <p class="mr-auto">{{members.length}}人</p>
          <v-btn
            color="#707070" dark
            data-testid="gotomemview"
            @click="memview=true"
            class="rounded-xl mr-8"
            v-if="isAdmin&&!isSp"
          >
            表示
          </v-btn>  
          <v-btn
            color="#707070" dark
            data-testid="gotomemviewsp"
            @click="memviewsp=true"
            class="rounded-xl mr-8"
            v-if="isAdmin&&isSp"
          >
            管理
          </v-btn>            
        </v-col>

        <v-col class="pb-0">
          <div style="font-size:24px; color:#294A66">
            自治体職員
          </div>
        </v-col>
        <v-col class="d-flex pb-0">
          <p class="mr-auto">{{admins.gov.length}}人</p>
          <v-btn
            color="#707070" dark
            data-testid="gotoadminsview"
            @click="adminsview=true"
            class="rounded-xl mr-8"
            v-if="isAdmin&&!isSp"
          >
            管理
          </v-btn>              
        </v-col>
        <v-col class="pt-0">
          <v-btn
            elevation="0"
            width="50%"
            outlined
            @click="profileUid = admins.gov[0],profile=true"
          >
            <p class="pt-4"><span v-if="admins.gov" v-text="namelist[admins.gov[0]]"></span></p>
          </v-btn>
          <span class="ml-2" v-if="admins&&admins.gov&&admins.gov.length>1">ほか{{otherMemnum}}人</span>
        </v-col>

        <v-col class="d-flex pb-0">
          <p style="font-size:24px; color:#294A66" class="mb-0">お問い合わせ</p>
        </v-col>
        <v-col class="pb-0 d-flex" v-if="!editInquiry">
          <p v-if="config.inquiry&&config.inquiry.length>0" v-text="config.inquiry"></p>
          <p v-else>未登録</p>
          <v-btn
            color="#707070" dark
            data-testid="gotoadminsview"
            @click="editInquiry=!editInquiry,inquiryContent=config.inquiry,inquiryUrlContent=config.inquiryUrl"
            class="rounded-xl ml-auto mr-8"
            v-if="isAdmin&&!isSp"
          >
            管理
          </v-btn>
        </v-col>
        <v-col class="pb-0" v-if="editInquiry">
          <v-textarea
            v-model="inquiryContent"
            outlined
            name="input-7-4"
            label="お問い合わせ"
            value=""
          ></v-textarea>
          <v-text-field
            hide-details
            outlined
            v-model="inquiryUrlContent"
            label="お問い合わせ先URL"
          ></v-text-field>
        </v-col>
        <v-col v-if="editInquiry" class="d-flex">
          <v-btn rounded @click="submitInquiry()" class="ml-2">登録</v-btn>
          <v-btn rounded @click="editInquiry=false" class="ml-auto">キャンセル</v-btn>
        </v-col>

        <div v-if="isAdmin&&!isSp">
        <v-col class="pb-0">
          <p style="font-size:24px; color:#294A66" class="mb-0">スタンプ登録</p>
        </v-col>
        <v-col class="d-flex">
          <p class="mr-auto">未登録</p>
          <v-btn
            color="#707070" dark
            data-testid="gotostamp"
            class="rounded-xl mr-8"
            v-if="isAdmin&&!isSp"
          >
            ファイル登録
          </v-btn> 
        </v-col>

        <v-col class="pb-0">
          <p style="font-size:24px; color:#294A66" class="mb-0">地図の初期位置登録</p>
        </v-col>
        <v-col class="d-flex">
          <div class="mr-auto">
            <p v-if="config&&config.location">登録済み<span v-if="config.location.name">:{{ config.location.name }}</span></p>
            <p v-else>未登録</p>
          </div>
          <v-btn
            color="#707070" dark
            data-testid="gotomap"
            class="rounded-xl mr-8"
            @click="setMap = true, setLocate()"
          >
            設定
          </v-btn> 
        </v-col>

        <v-col class="pb-0">
          <p style="font-size:24px; color:#294A66" class="mb-0">[ホーム]{{$t('前提情報')}}設定ページの設定</p>
        </v-col>
        <v-col class="d-flex align-center">
          <router-link to="/home" class="mr-8" style="text-decoration:none;">
            <v-btn
              color="#707070" dark
              data-testid="gotozentei"
              class="rounded-xl"
            >
              設定
            </v-btn>
          </router-link>
          <p class="text-caption mb-0">最終更新:<span class="text-caption" v-if="config.home_preinfoTime" v-text="config.home_preinfoTime.toDate().toLocaleString()"></span></p>
        </v-col>

        <v-col class="pb-0">
          <p style="font-size:24px; color:#294A66" class="mb-0">[ホーム]スケジュールページの設定</p>
        </v-col>
        <v-col class="d-flex align-center">
          <router-link to="/home" class="mr-8" style="text-decoration:none;">
            <v-btn
              color="#707070" dark
              data-testid="gotozentei"
              class="rounded-xl"
            >
              設定
            </v-btn>
          </router-link>
          <p class="text-caption mb-0">最終更新:<span class="text-caption" v-if="config.home_meetingTime" v-text="config.home_meetingTime.toDate().toLocaleString()"></span></p>
        </v-col>

        <v-col class="pb-0">
          <p style="font-size:24px; color:#294A66" class="mb-0">[ホーム]お知らせページの設定</p>
        </v-col>
        <v-col class="d-flex align-center">
          <router-link to="/home" class="mr-8" style="text-decoration:none;">
            <v-btn
              color="#707070" dark
              data-testid="gotozentei"
              class="rounded-xl"
            >
              設定
            </v-btn>
          </router-link>
          <p class="text-caption mb-0">最終更新:<span class="text-caption" v-if="config.home_newsTime" v-text="config.home_newsTime.toDate().toLocaleString()"></span></p>
        </v-col>
      </div>

      </v-col>
      </v-row>
    </v-tab-item>
    <!--属性設定-->
    <v-tab-item v-if="Object.keys(attributionDef).length" :transition="false" :style="isSp ? 'height: 100dvh; overflow-y: scroll; overflow-x: hidden;' : 'height: 90vh; overflow-y: scroll; overflow-x: hidden;'">
      <div class="d-flex pa-2">
        <p
          class="font-weight-bold mb-0"
          style="font-size:30px; color:#2B2B2B"          
        >属性設定</p>
        <v-spacer></v-spacer>
        <v-btn
          tile
          icon
          @click="$emit('closeSetting',false)"
        >
          <v-icon color="#E64550" size="50">mdi-close</v-icon>
        </v-btn>
      </div>
      <!-- 属性設定機能 -->
      <attributionSetting />
    </v-tab-item> 
    <!--通知設定-->
    <v-tab-item :transition="false">
      <div class="d-flex pa-2">
        <p
          class="font-weight-bold mb-0"
          style="font-size:30px; color:#2B2B2B"          
        >通知設定</p>
        <v-spacer></v-spacer>
        <v-btn
          tile
          icon
          @click="$emit('closeSetting',false)"
        >
          <v-icon color="#E64550" size="50">mdi-close</v-icon>
        </v-btn>
      </div>
      <!-- 通知設定機能 -->
      <notifySetting />
    </v-tab-item> 
    <!--言語設定-->
    <v-tab-item :transition="false">
      <div class="d-flex pa-2">
        <p
          class="font-weight-bold mb-0"
          style="font-size:30px; color:#2B2B2B"          
        >言語設定</p>
        <v-spacer></v-spacer>
        <v-btn
          tile
          icon
          @click="$emit('closeSetting',false)"
        >
          <v-icon color="#E64550" size="50">mdi-close</v-icon>
        </v-btn>
      </div>
      <v-card 
        flat
        height="75vh"
      >
        <v-card-text>
          <v-col class="px-8 py-0">
            <v-radio-group
              v-model="lang"
              column
            >
              <v-radio
                label="日本語"
                color="#008CFF"
                value="japanese"
              ></v-radio>
              <v-radio
                label="English(未対応)"
                color="#008CFF"
                value="english"
                disabled
              ></v-radio>
            </v-radio-group>
          </v-col>
        </v-card-text>
      </v-card>
    </v-tab-item>
    <!--アナウンス-->
    <v-tab-item :transition="false" class="overflow-y-auto" v-if="isAdmin&&!isSp">
      <div class="d-flex pa-2">
        <p
          class="font-weight-bold mb-0"
          style="font-size:30px; color:#2B2B2B"          
        >アナウンス</p>
        <v-spacer></v-spacer>
        <v-btn
          tile
          icon
          @click="$emit('closeSetting',false)"
        >
          <v-icon color="#E64550" size="50">mdi-close</v-icon>
        </v-btn>
      </div>
      <v-card 
        flat
        height="75vh"
      >
        <v-card-text class="pt-0">
          <v-col>
            <p class="text-subtitle-2" style="color:#2B2B2B">ユーザー全体、もしくは特定のユーザーに対して、アナウンスします</p>
          </v-col>
          <v-col class="">
            <p
              class="font-weight-bold"
              style="font-size:20px; color:#294A66"
            >
              アナウンス先
            </p>
            <v-radio-group
              v-model="toUser"
              column
            >
              <v-radio
                label="ユーザー全体（送信者除く）"
                color="#008CFF"
                value="all"
              ></v-radio>
              <v-radio
                label="特定のユーザー"
                color="#008CFF"
                value="theUser"
              ></v-radio>
            </v-radio-group>
          </v-col>
          <v-col v-if="toUser=='theUser'">
            <v-autocomplete
              v-model="toTheUser"
              :items="members"
              item-value="uid"
              item-text="name"
              dense
              filled
              label="ユーザーを選ぶ"
              clearable
              multiple
            ></v-autocomplete>
          </v-col>

          <v-col class="pb-0">
            <p style="font-size:24px; color:#294A66" class="mb-0">アナウンス内容</p>
          </v-col>
          <v-col class="pb-0">
            <v-textarea
              v-model="content"
              outlined
              name="input-7-4"
              label="アナウンス内容"
              value=""
            ></v-textarea>
            <!-- 「重要」チェックボックスの設定 -->
            <v-checkbox
              v-if="toUser=='theUser'"
              v-model="isImportant"
              label="重要"
              hint="特定のユーザー選択時のみ"
              color="#008CFF"
              hide-details
            ></v-checkbox>
          </v-col>
        </v-card-text>
        <v-card-actions class="mb-4">
          <v-spacer></v-spacer>
          <v-btn rounded class="white--text" color="deepAlgae" @click="setNotify()" :disabled="(toUser=='theUser'&&!toTheUser)||content.length==0">送信</v-btn>
        </v-card-actions>

        <div class="mx-4 my-0">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header style="color:#008CFF;" color="#00000029">
                アナウンス履歴
              </v-expansion-panel-header>
              <v-expansion-panel-content class="pa-0">
                <div v-for="pro in notify" :key="pro.sort">
                  <v-sheet elevation="0" color="#dcdcdc" width="100%" class="pa-2 mt-2" v-if="pro.sort">
                    <p class="text-right mb-0 mt-2" v-dompurify-html="pro.sort.slice(0,4) + '/' + pro.sort.slice(4,6) + '/' + pro.sort.slice(6,8)"></p>
                    <p class="qimg" v-dompurify-html="pro.content"></p>
                  </v-sheet>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>                          
        </div>

        <!-- ダミー -->
        <v-card-actions style="height=10px" class="mt-2 mb-0"></v-card-actions>
      </v-card>
    </v-tab-item>
    <!--Lid順設定-->
    <v-tab-item :transition="false" class="overflow-y-auto" v-if="isAdmin">
      <v-card-title>
        <p class="font-weight-bold" style="font-size:30px; color:#2B2B2B">Lid並び順設定（管理者専用）</p>
        <v-spacer></v-spacer>
        <v-btn
          tile
          elevation="0"
          color="#008CFF"
          class="white--text"
          @click="$emit('closeSetting',false)"
        >
          閉じる
        </v-btn>
      </v-card-title>
      <v-card 
        flat
        height="540px"
      ><lidsort/></v-card>
    </v-tab-item>
    <!--Lidフォルダ作成-->
    <v-tab-item :transition="false" class="overflow-y-auto" v-if="isAdmin">
      <v-card-title>
        <p class="font-weight-bold" style="font-size:30px; color:#2B2B2B">Lidフォルダ作成(管理者専用)</p>
        <v-spacer></v-spacer>
        <v-btn
          tile
          elevation="0"
          color="#008CFF"
          class="white--text"
          @click="$emit('closeSetting',false)"
        >
          閉じる
        </v-btn>
      </v-card-title>
      <v-card 
        flat
        height="540px"
      ><lidfolder/></v-card>
    </v-tab-item>
    <!--Lidフォルダ削除-->
    <v-tab-item :transition="false" class="overflow-y-auto" v-if="isAdmin">
      <v-card-title>
        <p class="font-weight-bold" style="font-size:30px; color:#2B2B2B">Lidフォルダ削除(管理者専用)</p>
        <v-spacer></v-spacer>
        <v-btn
          tile
          elevation="0"
          color="#008CFF"
          class="white--text"
          @click="$emit('closeSetting',false)"
        >
          閉じる
        </v-btn>
      </v-card-title>
      <v-card 
        flat
        height="540px"
      ><delfolder/></v-card>
    </v-tab-item>
    <!--ポリシー-->
    <v-tab-item :transition="false">
      <div class="d-flex pa-2">
        <p
          class="font-weight-bold mb-0"
          style="font-size:30px; color:#2B2B2B"          
        >ポリシー</p>
        <v-spacer></v-spacer>
        <v-btn
          tile
          icon
          @click="$emit('closeSetting',false)"
        >
          <v-icon color="#E64550" size="50">mdi-close</v-icon>
        </v-btn>
      </div>
      <v-card 
        flat
        height="75vh"
      >
        <div class="mx-auto pa-4 text-center">
          <p>
            <a href="https://drive.google.com/file/d/13yqWr0tXj2eb8898OBl_EbukMIASPZuK/view?usp=sharing">利用規約</a>
          </p>
          <p>
            <a href="https://drive.google.com/file/d/1fSPDIhzqH4BPfpUUCPvTSGy8_d227hCP/view">プライバシーポリシー</a>
          </p>
          <p>
            上記の２つをダウンロードして閲覧する場合は<a href="https://drive.google.com/file/d/1sOVrGMspt3bUgiglo8ygGhPhaiPo_cuz/view?usp=share_link">こちら（PDF）</a>
          </p>
        </div>
        <!-- trusteのロゴ -->
        <div class="mx-auto text-center">
          <a href="https://www.truste.or.jp/hssl/validate/01650.php" target="_blank">
            <img src="../assets/TRUSTe_certified_privacy_en.png" alt="TRUSTe Privacy Certification" style="width: 200px; height: auto;">
          </a>
        </div>
      </v-card>
    </v-tab-item>
    <!--バージョン情報-->
    <v-tab-item :transition="false">
      <div class="d-flex pa-2">
        <p
          class="font-weight-bold mb-0"
          style="font-size:30px; color:#2B2B2B"          
        >バージョン情報</p>
        <v-spacer></v-spacer>
        <v-btn
          tile
          icon
          @click="$emit('closeSetting',false)"
        >
          <v-icon color="#E64550" size="50">mdi-close</v-icon>
        </v-btn>
      </div>
      <v-card flat height="75vh"><v-img class="mx-auto" src="../assets/logo/liqlidv2.png" width="90%"></v-img></v-card>
    </v-tab-item>
  </v-tabs>

  <!--管理者リスト画面-->
  <v-dialog
    v-model="adminsview"
    width="800"
    persistent
  >
    <listAdm mode="base" @listAdmClose="oneaddAdmin"></listAdm>
  </v-dialog>
  <!--メンバーリスト画面-->
  <v-dialog
    v-model="memview"
    width="800"
    persistent
  >
    <listMem mode="base" @listMemClose="oneaddMember" @lidCandiMems="onecandiMembers"></listMem>
  </v-dialog>
  <!--メンバーリスト画面-->
  <v-dialog
    v-model="memviewsp"
    width="800"
    persistent
    fullscreen
  >
    <listMemsp mode="base" @listMemSpClose="oneaddMember" @lidCandiMems="onecandiMembers"></listMemsp>
  </v-dialog>  
  <!--プロフィール画面-->
  <profile_display
    :profile="profile"
    :profuid="profileUid"
    :device="device"
    @closeProfile="closeProfile"
  ></profile_display>
  <v-dialog v-model="setMap" scrollable max-width="80%" style="z-index:10000;">
    <v-card style="overflow:hidden; border: 3px solid black;" outlined color="white" height="80vh">
      <v-card-actions class="d-flex allign-center" style="z-index:100">
        <p><span style="font-size:30px;" class="title mr-6"><v-icon >mdi-map-marker</v-icon>位置情報入力</span></p>
        <v-spacer></v-spacer>
        <v-text-field label="位置の名称" v-model="placename" solo style="width:50px"></v-text-field>
        <v-spacer></v-spacer>
        <v-btn icon tile @click="setMap=false">
          <v-icon color="#E64550" size="50">mdi-close </v-icon>
        </v-btn>
      </v-card-actions>
      <l-map class="mx-auto" ref="map" @click="addMarkerInput" style="height:100%; width:100%;" :zoom="15" :center="[data_location_lat, data_location_lng]">
        <l-tile-layer :url="'http://{s}.tile.osm.org/{z}/{x}/{y}.png'" :attribution="attribution"></l-tile-layer>
        <template>
          <l-marker :lat-lng="[markers.lat, markers.lng]">
            <l-popup>
              <div class="primary--text">位置情報</div>
              <!-- <div v-for="(title, index) in marker.titles"
              :key="'tit-'+index">
                <a :href="title.uri" target="_blank">{{title.title}}</a>
              </div> -->
            </l-popup>  
          </l-marker>
        </template>          
      </l-map>
      <v-card-actions class="px-4 py-0" style="z-index:100">
        <p text-center my-5 v-if="latlngInput!={}">({{latlngInput.lat}}, {{latlngInput.lng}})</p>
        <v-spacer></v-spacer>
        <v-btn 
          class="text-h6 font-weight-bold white--text" 
          color="#008CFF"
          rounded
          x-large
          height="50"
          width="150"
          depressed
          @click="submitMap()"
          :disabled="!latlngInput.lat"
          >登録
        </v-btn>
        <v-btn 
          class="text-h6 font-weight-bold white--text" 
          color="#E64550"
          rounded
          x-large
          height="50"
          width="150"
          depressed
          @click="setMap = false, latlngInput.lat = data_location_lat, latlngInput.lng = data_location_lng"
          >キャンセル
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  </div>
</template>

<script>
import firebase from 'firebase'
import { config, title } from 'process'
import listAdm from './listAdm.vue'
import listMem from './listMem.vue'
import listMemsp from './memSp.vue'
import upImage_logo from './upImage_logo.vue'
import profile_display from "./profile/profile_display.vue"
import 'leaflet/dist/leaflet.css'
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
import L from 'leaflet';
// import notifySetting from './notifySetting.vue'
// import lidsort from './settings/lidsort.vue'
// import lidfolder from './settings/lidfolder.vue'
// import delfolder from './settings/delfolder.vue'
const attributionSetting = () => import('./attributionSetting.vue')
const notifySetting = () => import('./notifySetting.vue')
const lidsort = () => import('./settings/lidsort.vue')
const lidfolder = () => import('./settings/lidfolder.vue')
const delfolder = () => import('./settings/delfolder.vue')
import Vue from 'vue'
import VueMq from 'vue-mq'
import Toasted from "vue-toasted";
Vue.use(Toasted,{iconPack : 'material'})
Vue.use(VueMq, {
  breakpoints: { // default breakpoints - customize this
    sp: 959,
    pc: 960
  },
  defaultBreakpoint: 'pc' // customize this for SSR
})
//import VoteProject from '../components/dashboard/voteProject.vue';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});
export default ({
  props: {
    isSp: Boolean
  },
  components:{
    listAdm,
    listMem,
    listMemsp,
    //deleteAccount,
    upImage_logo,
    attributionSetting,
    notifySetting,
    profile_display,
    LMap, 
    LTileLayer,
    LMarker,
    LPopup,
    lidfolder,
    lidsort,
    delfolder
  },
  data () {
    return {
    db:null,
    pageTitle: this.$route.name,
    uploadedImage: "",
    lang: 'japanese',
    memview:false,
    memviewsp:false,
    profile:false,
    profileUid:"",
    img_name: '',
    adminsview:false,
    newbasetitle: "",
    only: true,
    toUser: "all",
    content: "",
    isImportant: false,
    toTheUser: "",
    editTitle: false,
    editInquiry: false,
    inquiryContent: "",
    inquiryUrlContent: "",
    setMap: false,
    attribution:'&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    data_location_lat: Number(process.env.VUE_APP_LOCATION_LAT || 35.6813320349034), //初期位置
    data_location_lng: Number(process.env.VUE_APP_LOCATION_LNG || 139.76716771167693), //初期位置
    data_location_name: "",
    latlngInput: {}, //ピン指したところ
    markers: {lat: 0, lng: 0}, //ピンの位置
    placename: "初期位置",
    logoSrc: "",
    logoSrc_large:"",
    device: "pc",
  }},
  computed:{
    attributionDef() {
      return this.$store.state.auth.data.attributionDef;
    },
    otherMemnum: function(){
      return this.admins.gov.length - 1
    },
    admins(){
      return this.$store.state.admins
    },
    liqAdmins(){
      return this.$store.state.liqAdmins
    },
    namelist(){
      return this.$store.state.namelist
    },
    isAdmin(){
      return this.$store.state.isAdmin
    },
    basetitle(){
      return this.$store.state.basetitle
    },
    lid(){
      return this.$store.state.lid
    },
    alid(){
      return this.$store.state.alid
    },
    config(){
      if(this.$store.state.config.logoSrc) console.log(this.$store.state.config.logoSrc)
      else console.log("img")
      return this.$store.state.config
    },
    members(){
      return this.$store.state.members
    },
    uid() {
      return this.$store.state.auth?.user?.uid || '';
    },
    currentName() {
      return this.$store.state.auth.user.displayName;
    },
    isAuthed() {
      return this.$store.state.auth?.isAuthed;
    },
    notify(){
      return this.$store.state.notifys
    },
  },
  created(){
    this.db = firebase.firestore()
    this.$emit("getm",true)
    this.getImageUrl_first()
    //console.log("created",this.pageTitle,this.currentName,this.uid)
  },
  mounted(){
    this.markers = {lat: this.data_location_lat, lng: this.data_location_lng}
    this.device = this.$mq;
  },
  updated(){
    if(this.basetitle.length>0&&this.only){
      this.newbasetitle = this.basetitle
      this.only=false
    }
  },
  watch:{
    uid:{
      handler: function(v,ov) {
        //console.log("uid変更",ov,v)
      }
    },
    setMap: {
      handler() {
        // resizeする
        setTimeout(function () {
            window.dispatchEvent(new Event('resize'));
        }, 10);
      }
    },
    /*
    lid:{
      handler: function(val, oldVal) {
        //console.log("lid変更"+val,oldVal)
      }
    },
    */
  }, 
  methods: {
    setLocate(){
      if(this.config&&this.config.location)
      this.data_location_lat = this.config.location.lat
      this.data_location_lng = this.config.location.lng
      if(this.config.location.name){
        this.data_location_name = this.config.location.name
        this.placename = this.config.location.name
      } 
      this.markers = {lat: this.data_location_lat, lng: this.data_location_lng}
      this.latlngInput.lat = this.data_location_lat
      this.latlngInput.lng = this.data_location_lng
    },
    getImageUrl(filename, logo){
      //console.log("res-from-cp")
      if (logo !=""){
        let filepath = "logo/"+filename+"-sum.jpeg";
        const ref = firebase.storage().ref(filepath);
        ref.getDownloadURL().then((url)=>{
          this.logoSrc = url
          //console.log("logo: ",url)
        });
      }else{
        this.logoSrc = "";
      }
    },
    addMarkerInput(event) {
      //console.log(event.latlng);
      this.latlngInput = event.latlng;
      //console.log(this.latlngInput);
      this.markers = this.latlngInput;
      //console.log(this.markers.lat);
    },
    //ファイルアップロード
    onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files;
      this.createImage(files[0]);
      // 拡張子で分ける（※.が1つの想定です）
      const imgNameExe = files[0].name.split('.');

      // 拡張子から前
      let imgName = imgNameExe[0];

      // 拡張子から後ろ
      const imgExe = imgNameExe[1];

      // 表示したいMaxのByte数（全角10文字、半角20文字）
      const maxBytes = 20;
      const imgNameBytes = encodeURIComponent(imgName).replace(/%../g, 'x').length;

      // 画像ファイルとMax Byte数の比較
      if (imgNameBytes > maxBytes) {
        const zenkaku = imgNameBytes - imgName.length;
        if (zenkaku > 0) {
          imgName = imgName.slice(0, maxBytes / 2 - imgName.length) + '..';
        } else {
          imgName = imgName.slice(0, maxBytes - imgNameBytes) + '..';
        }
      }

      // 短くカットしたものと.と拡張子の文字列の連結
      imgName = imgName + '.' + imgExe;
      this.img_name = imgName;
    },
    // アップロードした画像を表示
    createImage(file) {
      const reader = new FileReader();
      reader.onload = e => {
        this.uploadedImage = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    //通知
    submitInquiry(){
      let self = this, inqA = "", inqB = ""
      if(this.inquiryContent) inqA = this.inquiryContent
      if(this.inquiryUrlContent) inqB = this.inquiryUrlContent
      
      this.db.collection("0").doc("config").update({
        inquiry: inqA,
        inquiryUrl: inqB,
        updatedAt: firebase.firestore.FieldValue.serverTimestamp()
      },{merge:true}).then(function(docRef) {
      // 保存に成功した時
        //console.log("Document written with ID: ", docRef.id)
        //console.log("問い合わせ設定成功：",self.inquiryContent,self.inquiryUrlContent)
        self.$store.dispatch('settingConfig',{
          type: "inq",
          el: {
            inquiry: inqA,
            inquiryUrl: inqB,
          }
        })
        self.editInquiry = false
      }).catch(function(error) {
        // 保存に失敗した時
        console.error("Error adding document: ", error)
      }) 
    },
    submitMap(){
      let self = this
      this.db.collection("0").doc("config").update({
        location:{
          lat: self.latlngInput.lat,
          lng: self.latlngInput.lng,
          name: self.placename,
        },
        updatedAt: firebase.firestore.FieldValue.serverTimestamp()
      },{merge:true}).then(function(docRef) {
      // 保存に成功した時
        //console.log("Document written with ID: ", docRef.id)
        console.log("地図設定成功：",self.latlngInput)
        self.$store.dispatch('settingConfig',{
          type: "map",
          el: {
            lat: self.latlngInput.lat,
            lng: self.latlngInput.lng,
            name: self.placename,
          }
        })
        self.setMap = false
      }).catch(function(error) {
        // 保存に失敗した時
        console.error("Error adding document: ", error)
      }) 
    },
    //プロフィール更新
    submitBasetitle() {
      let self = this
      this.editTitle=false
      if(self.newbasetitle!=self.basetitle){
        this.db.collection("0").doc("config").update({
          title: self.newbasetitle,
          updatedAt: firebase.firestore.FieldValue.serverTimestamp()
        },{merge:true}).then(function(docRef) {
        // 保存に成功した時
          //console.log("Document written with ID: ", docRef.id)
          self.$store.dispatch('settingConfig',{
            type: "title",
            el: self.newbasetitle,
          })
          self.$store.commit('setbasetitle', self.newbasetitle)
        }).catch(function(error) {
          // 保存に失敗した時
          console.error("Error adding document: ", error)
        })        
      }
    },
    submitemailpass(){
      if(this.newEmail){
        this.$store.dispatch('auth/updateEmail', this.newEmail)
      }
      if(this.newPass){
        this.$store.dispatch('auth/updatePassword', this.newPass)
      }
    },
    setNotify(){
      let type = 27,isPri = false,address = "all"
      if(this.toUser!=="all") {
        type=30, isPri=true,address = this.toTheUser
      } else {
        this.isImportant = false
      }
      const title = this.isImportant ? "重要なお知らせ":"アナウンス"
      const tag = this.isImportant ? "重要":"アナウンス"
      console.log("notify",address)
      this.$store.dispatch('setConfigNotify',({title:title,content:this.content,address:address,type:type,tag:tag,usePush:true,useMail:true,useLine:true,isImportant:this.isImportant,isPri:isPri}))
      isPri = false
      address = "all"
      type=27
      this.content = ""
      this.showToast("通知を送信しました")
    },
    showToast(message="完了しました"){
      this.$toasted.success(message, {
        theme: "bubble", 
        position: "top-center", 
        duration : 5000,
      });
    },
    onecandiMembers(el){
      this.candiMem = el
    },
    oneaddMember(el){
      this.memview = el
      this.memviewsp = el
    },
    oneaddAdmin(el){
      this.adminsview = el
    },
    getImageUrl_first(){
      console.log("res-from-cp")
      if (!this.logoSrc){
        let filepath = "logo/"+"logo-sum.jpeg";
        const ref = firebase.storage().ref(filepath);
        ref.getDownloadURL().then((url)=>{
          this.logoSrc = url
          console.log("logo: ",url)
        });
        let filepath2 = "logo/"+"logo.jpeg";
        const ref2 = firebase.storage().ref(filepath2);
        ref2.getDownloadURL().then((url)=>{
          this.logoSrc_large = url
          console.log("logo_large: ",url)
        });
      }
    },
    closeProfile() {
      this.profile = false;
    },
  },

}) 
</script>

<style scoped>
.card{
  border-radius:10px;
}
*{
  font-family:mplus-2c-medium;
}
* ::-webkit-scrollbar { 
  display: none;
}

</style>
